/**
 * ComponentItem — compact draggable toggle (matches SubpageSectionToggles style).
 * Clicking selects the component and auto-switches to the Texte tab.
 */
import { componentMeta } from '@/data/component-meta';

interface ComponentData {
  id: string;
  type: string;
  name: string;
  enabled: boolean;
  data: any;
}

interface ComponentItemProps {
  component: ComponentData;
  isActive: boolean;
  onSelect: (id: string) => void;
  onToggle: (id: string) => void;
  onDragStart: (e: React.DragEvent<HTMLDivElement>, id: string) => void;
  onDragEnd: () => void;
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
}

export function ComponentItem({
  component,
  isActive,
  onSelect,
  onToggle,
  onDragStart,
  onDragEnd,
  onDragOver,
}: ComponentItemProps) {
  const meta = componentMeta[component.type] || {
    icon: '\u{1F4E6}',
    description: '',
  };

  return (
    <div
      className={`component-item${isActive ? ' is-active' : ''}${!component.enabled ? ' is-disabled' : ''}`}
      onClick={() => onSelect(component.id)}
      draggable
      onDragStart={(e) => onDragStart(e, component.id)}
      onDragEnd={onDragEnd}
      onDragOver={onDragOver}
    >
      <span className="component-item__drag" title="Ziehen zum Sortieren">⠿</span>
      <span className="component-item__icon">{meta.icon}</span>
      <span className="component-item__label">{component.name}</span>
      <input
        type="checkbox"
        className="component-item__input"
        checked={component.enabled}
        onChange={() => onToggle(component.id)}
        onClick={(e) => e.stopPropagation()}
      />
      <span className="component-item__switch" />
    </div>
  );
}
